// extracted by mini-css-extract-plugin
export default {"root":"CloneIcon_root__Ke9AD","st2":"CloneIcon_st2__uaQct"};